import type { AxiosError } from 'axios'

import { redirect } from '@tanstack/react-router'

import { localStorageKeys } from '@/app/config/consts'
import { UnauthorizedPageRoute } from '@/app/routes/unauthorized-page'
import { AxiosApiInstance } from '@/shared/lib/axios'
import { getOpenedVerification } from '@/shared/lib/public-form-verification'
import { FORM_SYNC_CLIENT_ID } from '@/widgets/forms'

// Every page that renders a verification form (the form preview page, the chat-only page, the
// onboarding page once a form is opened from its chat, ...) needs the verification-link token
// attached to its API calls — so this is registered once, by whichever of them loads first.
let interceptorsRegistered = false
export function registerPublicFormsInterceptors() {
  if (interceptorsRegistered) return
  interceptorsRegistered = true

  AxiosApiInstance.interceptors.request.use(
    (config) => {
      const url = new URL(window.location.href)
      // /onboarding keeps the opened verification out of the URL.
      const verificationId = url.searchParams.get('verificationId') ?? getOpenedVerification()?.verificationId
      if (!verificationId) return config

      const data = localStorage.getItem(localStorageKeys.verificationId(verificationId))
      if (!data) return config

      const parsedData = JSON.parse(data)
      config.headers['x-user-client-token'] = parsedData.xUserClientToken
      // Lets the form-sync channel tag this tab's writes, so it can skip its own echoes.
      config.headers['x-form-sync-client'] = FORM_SYNC_CLIENT_ID
      return config
    },
    (error) => Promise.reject(error),
  )

  AxiosApiInstance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error.response?.status === 401) {
        redirect({ to: UnauthorizedPageRoute.path })
      }
      return Promise.reject(error)
    },
  )
}
